export default __webpack_public_path__ + "static/media/m-assortedpkhali.5323075b.png";